import { render, staticRenderFns } from "./BBSectionLoader.vue?vue&type=template&id=b2aceeb6&"
import script from "./BBSectionLoader.vue?vue&type=script&lang=js&"
export * from "./BBSectionLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports